export const catalogueThumbsCount = (screenWidth: number) => {
  if (screenWidth > 1920) {
    return 10;
  } else if (screenWidth <= 1920 && screenWidth > 1680) {
    return 10;
  } else if (screenWidth <= 1680 && screenWidth > 1440) {
    return 8;
  } else if (screenWidth <= 1440 && screenWidth > 1240) {
    return 7;
  } else if (screenWidth <= 1240 && screenWidth > 1024) {
    return 6;
  } else if (screenWidth <= 1024 && screenWidth > 768) {
    return 5;
  } else if (screenWidth <= 768 && screenWidth > 500) {
    return 4;
  } else {
    return 3;
  }
};
